import type { ProductCategoryMappingV2 } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GcvAdminApi } from 'api';
import { PRODUCT_CATEGORY_MAP_V2_KEY } from 'tanstack-hooks/keys';

export function useCreateProductCategoryMapV2Rows() {
  const gcvAdminApi = new GcvAdminApi();
  const queryClient = useQueryClient();

  const { mutateAsync: createProductCategoryMapV2Rows, isPending: isCreatingProductCategoryMapV2Rows } =
    useMutation({
      mutationKey: [PRODUCT_CATEGORY_MAP_V2_KEY, 'create'],
      mutationFn: async (rows: ProductCategoryMappingV2[]) =>
        gcvAdminApi.createProductCategoryMapV2Rows(rows),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [PRODUCT_CATEGORY_MAP_V2_KEY] });
      },
      meta: {
        snackbarSuccessMessage: 'Product category mapping created successfully.',
        snackbarErrorMessage:
          'There was an issue creating the product category mapping. It may already exist, or please try again.'
      }
    });

  return { createProductCategoryMapV2Rows, isCreatingProductCategoryMapV2Rows };
}
